import { useState, useCallback } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { API_URL } from "../../utils/ApiUrl";
import RedeemTask1 from "../write/redeemTask1";
import RedeemTask from "../write/redeemTask";
import CustomToast from '../../components/CustomToast';


const useClaimReward = (taskData, setLoader, fetchTaskData, updateTaskStatus, handleClose4Claim, handleClose6Claim, handleShow4Claim, handleShow6Claim) => {
    const [selectedIs, setSelectedIs] = useState(null);
    const [creater, setCreat] = useState(null);
    const { redeemTask1 } = RedeemTask1();
    const { redeemTask } = RedeemTask();
    const aditProfile = async () => {
        let accessToken = localStorage.getItem("accessToken");
        setLoader(true);
        var config = {
            method: "patch",
            url: `${API_URL}participants/${selectedIs}/claim-reward`,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${accessToken}`, // Include the access token here
            },
            data: {
                isClaimed: true,
            },
        };
        try {
            let response = await axios(config);

            if (response) {
                // getProfile();
                fetchTaskData();
                setLoader(false);
            }
        } catch (error) {
            console.error("Error occurred while creating task:", error);
            setLoader(false);
            // toast.error(error.message);
        }
    };
    const claimToken = async () => {
        let sign = localStorage.getItem("sign");
        // // console.log(winnerData?.task, 'sddsadasasd');\
        // console.log(creater, sign, 'signsignsign');
        setLoader(true);
        try {
            let value = await redeemTask(creater, sign);
            if (value) {
                // handleShow5();
                await updateTaskStatus(taskData?.id)
                // toast.success("Claimed Successfully");
                CustomToast.show('success', 'Success!', 'Claimed Successfully')

                handleClose4Claim();
                aditProfile();

                setLoader(false);
            }
        } catch (err) {
            // console.log(err, "contract erro");
            setLoader(false);
            // toast.error("Something went wrong!");
            CustomToast.show('error', 'Error!', 'Something went wrong!')
        }
    };
    // console.log(taskData, 'taskDatataskData');

    const claimToken1 = async () => {
        let sign = localStorage.getItem("sign");
        // // console.log(winnerData?.task, 'sddsadasasd');\
        // console.log(creater, sign, 'signsignsign');
        setLoader(true);
        try {
            let value = await redeemTask1(creater, sign);
            if (value) {
                // handleShow5();
                await updateTaskStatus(taskData?.id)
                // toast.success("Claimed Successfully");
                CustomToast.show('success', 'Success!', 'Claimed Successfully')
                handleClose6Claim();
                aditProfile();

                setLoader(false);
            }
        } catch (err) {
            // console.log(err, "contract erro");
            setLoader(false);
            // toast.error("Something went wrong!");
            CustomToast.show('error', 'Error!', 'Something went wrong!')
        }
    };
    const apiCallHandler = async (e) => {
        setLoader(true);
        setSelectedIs(e?.participants?.[0]?.id);
        let accessToken = localStorage.getItem("accessToken");
        var config = {
            method: "get",
            url: `${API_URL}tasks/${e?.id}/signature`,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${accessToken}`, // Include the access token here
            },
        };
        try {
            let response = await axios(config);

            if (response) {
                // console.log('Task created successfully:', response.data.data);
                handleShow4Claim();
                setCreat(response.data.data);
                setLoader(false);
                //    setWinnerData(e)
            }
        } catch (error) {
            console.error("Error occurred while creating task:", error);
            setLoader(false);
        }
    };
    const apiCallHandler1 = async (e) => {
        setLoader(true);
        setSelectedIs(e?.participants?.[0]?.id);
        let accessToken = localStorage.getItem("accessToken");
        var config = {
            method: "get",
            url: `${API_URL}tasks/${e?.id}/signature/dispute`,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${accessToken}`, // Include the access token here
            },
        };
        try {
            let response = await axios(config);

            if (response) {
                // console.log('Task created successfully:', response.data.data);
                handleShow6Claim();
                setCreat(response.data.data);
                setLoader(false);
                //    setWinnerData(e)
            }
        } catch (error) {
            console.error("Error occurred while creating task:", error);
            setLoader(false);
        }
    };
    const handleClaim = (data) => {
        if (data?.disputeWinnerId) {
            apiCallHandler1(data);
        } else {
            apiCallHandler(data);
        }
    };

    return {
        claimToken,
        claimToken1,
        handleClaim,
    };
};

export default useClaimReward;
